import { DatePipe, TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'format',
  pure: true
})
export class FormatPipe implements PipeTransform {
  private readonly mappings = new Map<string, string>([['dttm', 'datetime']]);
  private readonly titleCasePipe = new TitleCasePipe();
  private readonly datePipe = new DatePipe('en-US');

  public transform(
    value: any,
    args: string,
    length = 'short',
    transformer?: (value: string, context?: any) => string,
    context?: any
  ): any {
    if (args === 'custom') {
      return transformer(value, context);
    }

    if (args === 'key') {
      return this.formatKey(value);
    }

    if (this.isDateArg(args)) {
      return this.datePipe.transform(parseInt(value, 10) * 1000, 'short');
    }

    if (args.includes('json')) {
      value = JSON.stringify(value, null, '  ');
    }

    if (args === 'count' && value && value instanceof Array) {
      return value.length;
    }

    if (length === 'long') {
      return value;
    }

    if (value && value.length > 43) {
      return value.slice(0, 40) + '...';
    }

    return value;
  }

  private formatKey(value: string): string | null {
    const mappedValue = value
      .split('_')
      .map((part) => this.mappings.get(part) ?? part)
      .join(' ');

    return this.titleCasePipe.transform(mappedValue);
  }

  private isDateArg(args: string): boolean {
    return args.includes('dttm') || args.includes('date');
  }
}
